<template>
  <v-app>
    <v-main>
      <Navbar
        @action:redirect="redirect"
        class="d-print-none"
      />
      <v-container fluid>
        <v-row class="fill-height">
            <v-col>
                <transition name="fade">
                    <keep-alive :include="[
                      'Home',
                      'BudgetVariance',
                      'Prickles',
                      'Prickles2',
                      'Prickles3',
                      'XeroRecon',
                      'Mfc',
                    ]">
                      <router-view></router-view>
                    </keep-alive>
                </transition>
            </v-col>
        </v-row>
      </v-container>
      <Toasts :text="message" color="success" />
      <Toasts :text="saved" color="success" :timeout="-1" />
      <Toasts :text="error" color="error" :timeout="-1" />
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { components as auroraAppCore } from '@codehq/aurora-app-core';
import Navbar from './Navbar.vue';
import authHub from './authHub';
import errorHub from './errorHub';

const { Toasts } = auroraAppCore;

export default {
  components: {
    Navbar,
    Toasts,
  },
  name: 'App',
  data() {
    return {
      message: '',
      error: '',
      saved: '',
    };
  },
  computed: {
    ...mapGetters('app', ['isAnonymous']),
  },
  methods: {
    redirect(item) {
      this.$router.push(item.to).catch((e) => e);
    },

    async streamToString(stream) {
      const reader = stream.getReader();
      const decoder = new TextDecoder('utf-8');
      const result = await reader.read();
      const r = await decoder.decode(result.value);
      return r;
      // return reader.read().then((result) => decoder.decode(result.value));
    },
  },
  async created() {
    errorHub.$on('network.error', async (e) => {
      this.$root.$emit('network.error', e);
      this.error = '';
      const error = e.e;
      const body = await this.streamToString(error.body);
      const errorMsg = JSON.parse(body);
      this.$nextTick(() => {
        const msg = errorMsg?.error?.innererror?.message ?? 'There was an error communicating with the server';
        this.error = msg;
        this.$root.$emit('toast:error', msg);
      });
      // this.$root.$emit('network.error');
    });
    authHub.$on('user.unauthorized', () => {
      this.$router.push('/login');
    });
    this.$root.$on('auth:login', () => {
      this.$router.push('/');
      this.$root.$emit('toast:notify', 'Logged in successfully');
    });
    this.$root.$on('toast:notify', (msg) => {
      this.message = '';
      this.$nextTick(() => {
        this.message = msg;
      });
    });
    this.$root.$on('toast:saved', (msg) => {
      this.saved = '';
      this.$nextTick(() => {
        this.saved = msg;
      });
    });

    // setup application insights
    const instrumentationKey = process.env.VUE_APP_INSIGHTS_KEY;
    if (instrumentationKey?.length > 0) {
      const appInsights = new ApplicationInsights({
        config: {
          instrumentationKey,
        },
      });
      appInsights.loadAppInsights();
      appInsights.trackPageView();
    }
  },
  destroyed() {
    authHub.$off('user.unauthorized');
    errorHub.$on('network.error');
    this.$root.$off('auth:login');
    this.$root.$off('toast:notify');
  },
};
</script>
<style>
.vue-friendly-iframe {
  height: 700px;
  width: 100%;
}
@media print {
  .v-main {
    padding: 0px !important;
  }
}
</style>
